import { get } from 'lodash'

const pagination = {
  current_page: 0,
  firstItemIndex: 0,
  lastItemIndex: 0,
  per_page: 0,
  total: 0,
  total_pages: 0,
}

const initState = {
  products: [],
  pagination,
  isLoading: {
    loading: false,
    message: 'Fetching Wishlist...'
  },
}

const buyerWishlist = (state = initState, action) => {
  let products = null
  switch (action.type) {
    case 'WISHLIST_LOADING':
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          ...action.payload
        }
      }
    case 'SYNC_WISHLISTED_PRODUCTS':
      return {
        ...state,
        products: [...get(action, 'payload.data', [])],
        pagination: action.payload.pagination,
      }
    case 'ADD_WISHLISTED_PRODUCT':
      return {
        ...state,
        products: [
          ...state.products,
          { ...action.payload },
        ],
      }
    case 'DELETE_WISHLISTED_PRODUCT':
      products = state.products.filter(wProducts => wProducts.id !== action.payload[0].id)
      return {
        ...state,
        products,
      }
    default:
      return state
  }
}

export default buyerWishlist
